/**
 * @owner @Appboy/frontend-ix
 */

import { i18n } from "./createI18n";

// usage: https://confluence.braze.com/display/DASHINFRA/Internationalization+for+dashboard+developers
export default i18n;
